import React, { Component } from 'react';

// Components
import { PageSection } from '../PageSection';
import { DownArrow } from '../generic/DownArrow';

export class Header extends Component {
    render() {
        return (
            <PageSection sectionId="header">
                <div className="inner">
                    <img id="logo" src="./images/header/header-title-banner-smaller.png" alt="Plant Life Balance" />
                    <DownArrow />
                    <a id="webby-awards" href="https://www.webbyawards.com/winners/2018/mobile-sites-apps/general/lifestyle/plant-life-balance/" target="_blank"><img src="./images/generic/webby-awards.png" alt="Webby Awards" /></a>
                </div>

                {this.props.children}
            </PageSection>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/sections/Header.jsx